import React from "react";
import { Table, Button, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

const TableServices = ({ data, handleDelete, handleEdit }) => {

    const columns = [
        {
            title: "Id",
            dataIndex: "srv_id",
            key: "srv_id",
            align: "center",
            width: 80,
        },
        {
            title: "Servicio",
            dataIndex: "srv_service",
            key: "srv_service",
        },
        {
            title: "Acciones",
            key: "actions",
            align: "center",
            width: 150,
            render: (_, record) => (
                <>
                    <Button 
                        type="link" 
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                        title="Editar servicio"
                    >
                        Editar
                    </Button>
                    <Popconfirm 
                        title="¿Seguro que deseas eliminar este servicio?" 
                        onConfirm={() => handleDelete(record.srv_id)} 
                        okText="Sí" 
                        cancelText="No"
                    >
                        <Button 
                            danger 
                            type="link"
                            icon={<DeleteOutlined />}
                            title="Eliminar servicio"
                        />
                    </Popconfirm>
                </>
            ),
        },
    ];

    return (
        <Table
            className="custom-green-table"
            size="small"
            dataSource={data}
            columns={columns}
            pagination={{ pageSize: 10, position: ["bottomRight"] }}
            scroll={{ x: "max-content" }}
            rowKey="srv_id"
        />
    );
};

export default TableServices;
